import { useState, useCallback } from 'react';

export const useRefresh = () => {
  const [refreshValue, setRefreshState] = useState(Date.now());
  const refresh = useCallback(() => setRefreshState(Date.now()), []);
  return { refresh, refreshValue };
};
